import Main from "../Main";
import processStorageParameters from "./utils/process-storage-parameters";
import processStorageProperties from "./utils/process-storage-properties";
import processStorageParentRefs from "./utils/process-storage-refs";
import processStorageTimelines from "./utils/process-storage-timelines";
import processStorageValues from "./utils/process-storage-values";
import processValueFunctions from "./utils/process-value-functions";

/**
 * Create Store with triggers and timelines
 * @this {MainClassProps}
 */
Main.prototype.processStorage = function () {
  const storage = /** @type {StorageProps} */ this.storage;

  processStorageProperties(this);
  processStorageValues(this);
  processValueFunctions(storage);
  processStorageParentRefs(this);
  processStorageParameters(this);
  processStorageTimelines(this);
};

export default Main.prototype.processStorage;
